import MenuIcon from '@mui/icons-material/Menu';
import {
  Typography
} from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';

import { useEasyBrowserContext } from '../../browser';

const MenuPrincipalTaskBar = React.forwardRef(
  (_props: unknown, _ref: React.ForwardedRef<any>) => {
    const [open, setOpen] = React.useState(false);

    const { abrirPagina } = useEasyBrowserContext()!;

    const paginaMenu = {
      id: 'easy.schedule.menu.principal',
      descricao: 'Menu Principal',
      url: '/menu/menu',
      icone: "MenuIcon", 
      grupo: ['principal'],
      licenca: ['GERAL']
    }

  


    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: '150x',
          maxHeight: '40px',
        }}
      >
        

        <Typography
          variant="h6"
          noWrap
          component="div"
          sx={{ display: "flex", gap: 1, alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}
          onClick={() => abrirPagina(paginaMenu)}
          

        >
          <img src='/AppCodesh.png' height={40} width={150}>
          </img>
        </Typography>

       
      </Box>
    );
  }
);

export default MenuPrincipalTaskBar;
